/**
 * send notification to wireless standart that confirmation was failed
 * @memberof posPlatform.wireless
 */
export default function confirmFailed(...args) {
    return window.WS_ConfirmFailed(...args);
}